const APP_NAME = 'TimeLog';

interface PageTitleProps {
  title: string;
  fromLegacyPage?: boolean;
}

export const PageTitle = ({
  title,
  fromLegacyPage = false,
}: PageTitleProps) => {
  // legacy iframes emit a message to set the title in the React wrapper, which already includes the app name
  if (fromLegacyPage) {
    if (title.includes(`- ${APP_NAME} PSA`)) {
      // split at legacy app name part of page title and take only the first part, to also get rid of billing plan suffix
      const cleanedPageTitle = title.split(`- ${APP_NAME} PSA`)[0].trim();

      return <title>{`${cleanedPageTitle} | ${APP_NAME}`}</title>;
    }

    return <title>{title}</title>;
  }

  if (title.trim().length > 0) {
    return <title>{`${title} | ${APP_NAME}`}</title>;
  }

  return <title>{APP_NAME}</title>;
};
